import { redirect } from 'react-router';
import { loginContext } from '../../shared/context/loginContext';
import { getApiBaseUrl } from '../../shared/utils/apiBase';
import { t } from '../../i18next';

export const sessionMiddleware = async ({ context }) => {
  const apiBase = getApiBaseUrl();

  const response = await fetch(`${apiBase}/api/auth/session`, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  });
  const payload = await response.json();

  if (response.ok) {
    context.set(loginContext, payload.data);
  } else {
    switch (payload?.error) {
      case 'Token expired':
        const messageQuery = `?message=${t('error.invalid_session')}`;
        throw redirect(`/login${messageQuery}`);
      default:
        throw redirect(`/login`);
    }
  }
};
